const NAME = "RATING_SCALES";

export default NAME;
